export default {
  signIn: 'Sign In',
  signUp: 'Sign Up',
  email: 'Email',
  emailPlaceholder: 'Enter your email',
  password: 'Password',
  passwordPlaceholder: 'Enter your password',
  forgotPassword: 'Forgot your password?',
  confirmPassword: 'Confirm Password',
  confirmPasswordPlaceholder: 'Confirm your password',
  noAccount: "Don't have an account?",
  hasAccount: 'Already have an account?',
  signInWithGoogle: 'Sign in with Google',
  signUpWithGoogle: 'Sign up with Google',
  signInCta: 'Sign In',
  signUpCta: 'Sign Up',
  signUpCtaSubmitting: 'Signing Up...',
  authCTAGenericError: 'An error occurred',
  companyIndustries: 'Your company in a few words',
  changeEmail: 'Change my email',
  emailTakenException: 'This email address is already registered',
  currentEmailDoesNotMatch: 'The current email is incorrect. Please try again.',
  currentPasswordDoesNotMatch:
    'This email does not match your current email. Enter your current email.',
  passwordUpdated: 'Your password has been updated successfully.',
  updateEmailFailed: 'Failed to update email. Please try again.',
  enableAuthCTA: 'Continue with Google Authenticator',
  disableAuthCTA: 'Disable Two-factor authentication',
  confirmDisable: 'Confirm Disable',
  authCTADesableHint: 'Enter your 6-digit MFA code to disable MFA',
  authCTAScan: 'Scan this QR code with your authenticator app',
  authCTAVerify: 'Enter the verification code',
  codePlaceholder: 'Verification code ...',
  downloadGoogleAuth:
    'Two-factor authentication requires the download of the Google Authenticator application',
  register: {
    title: 'Create your account',
    userType: 'I am a...',
    client: 'Client',
    freelancer: 'Freelancer',
    submit: 'Create account',
    signInCta: 'Sign In',
    dataProtection: {
      title: 'Data Protection (Law 25):',
      paragraph1:
        'At Pigeons, we use your data solely to provide our service: create your profile, manage your projects, and connect you with potential prospects. Your information may be shared with relevant users when necessary for contact or collaboration.',
      paragraph2:
        'We also use certain data in an aggregated manner to improve the platform and our features. We never sell your data.',
      paragraph3:
        'At any time, you can request access, correction, or deletion of your personal information.',
    },
    acceptTerms: {
      prefix: 'I accept the',
      termsOfUse: 'Terms of Use',
      and: 'and the',
      privacyPolicy: 'Privacy Policy',
      suffix: ', and I understand the use of my personal data as described above.',
    },
    acceptNotifications:
      'I agree to receive notifications related to my activities on Pigeons (submissions, messages, projects, etc.).',
    acceptNewsletter:
      'I want to stay connected to the Pigeons community — newsletters, updates, and useful content.',
  },
  errors: {
    createAccount: 'Please complete the account information before continuing.',
    emailInvalid: 'Please enter a valid email address.',
    emailRequired: 'Please enter your email address.',
    emailRateLimited: 'Too many email attempts. Please wait a moment and try again.',
    resetPassword: 'We could not send the password reset email. Please try again.',
    invalidCredentials: 'Invalid email or password',
    accountCreation: 'Error creating account',
    generic: 'An unknown error occurred. Please contact support.',
    passwordTooShort: 'Password must be at least 8 characters long.',
    passwordUpperLower: 'Password must contain both uppercase and lowercase letters.',
    passwordNumberOrSpecial: 'Password must contain a number or a special character.',
    passwordInvalid: 'Incorrect password',
    passwordMismatch: 'Passwords do not match',
  },
  firstName: 'First Name',
  firstNamePlaceholder: 'Enter your first name',
  acceptTerms: 'I accept the',
  termsOfUse: 'Terms of Use',
  and: 'and',
  privacyPolicy: 'Privacy Policy',
  completeSignup: 'COMPLETE YOUR REGISTRATION',
  confirmEmail: {
    title: 'Check your emails',
    description:
      "We've just sent a confirmation link to <1>{{email}}</1>. Click the link to continue your registration.",
    resend: 'Resend confirmation email',
    resendIn: 'Resend possible in {{minutes}} min...',
    back: 'Back to home',
    newEmail: 'Your new email',
    confirmNewEmail: 'Confirm your new email',
    oldEmail: 'Your old email',
    confirmReceived: 'I received the email',
    emailInstruction: 'Please check your inbox at the address',
    close: 'Close',
    confirmationNotice: 'You will receive an email with a confirmation link.',
    sendLinkCurrentEmail: 'We have just sent an email to your ',
    sendLinkNewEmail: 'We have just sent an email to your ',
    newEmailIsNowEffective: 'Your new email is now effective.',
    securityNoticeCanContinue:
      'You have confirmed the request to change your email. You can now use it to sign in',
    securityNotice:
      'For security reasons, you must first confirm your request to change your email.',
    securityNoticeHaveConfirmed:
      'You have confirmed the request to change your email. You will now receive an email with a confirmation link to your new address',
    newAddress: 'new address',
    currentAddress: 'current address',
  },
  profileTypeStep: {
    welcome: 'Welcome to Pigeons',
    step: 'Step 1 of 3',
    completeInfo: 'Choose your profile type',
    stepDesc: 'First step out of three to finalize your subscription.',
    freelancerDescription:
      'As a freelancer, you can showcase your skills, apply for projects, and connect with clients looking for your expertise. Create an attractive profile to develop your independent career on Pigeons.',
    recruiterDescription:
      'As a recruiter, you can post projects, view freelancer profiles, and find the ideal talents for your needs. Manage your teams and projects efficiently with our dedicated tools for businesses and organizations.',
    inscription: 'Registration',
    as: 'You are registering as:',
    freelancer: 'Freelancer',
    recruiter: 'Recruiter',
    professional: 'Professional',
    company: 'Company',
    organization: 'Organization',
  },
  completeProfileStep: {
    welcome: 'Welcome to Pigeons',
    step: 'Step 2 of 3',
    completeInfo: 'Complete essential information',
    stepDesc: 'Second step out of three to finalize your subscription.',
    info1:
      'To help us personalize your experience and connect you with the right opportunities, please complete the essential information below. This will allow us to better match your profile with projects and clients that fit your skills and preferences.',
    info2:
      'Your information will remain confidential and will only be used to improve your experience on Pigeons. The more complete your profile, the easier it will be for clients to find and trust you.',
    inscription: 'Registration',
    professionalInfo: 'What are your professional details?',
    chooseImage: 'Choose a profile picture*',
    imageHint: 'Optimal format: .png\nMin 675px by 675px. Max size: 5MB',
    uploading: 'Uploading...',
    profilePreviewAlt: 'Profile preview',
    personalInfoDescriptionTitle: 'You are recruiting local talents for your personal needs.',
    personalInfoDescriptionSubtitle:
      'Example: family photography or event services, personal tax returns, notary services, creative projects or home-based projects, etc.',
    corporateInfoDescriptionTitle: 'You are recruiting on behalf of a company or organization.',
    corporateInfoDescriptionSubtitle:
      'Examples include web development, graphic design, marketing, writing, translation, etc.',
    organizationInfoDescriptionTitle: 'You are recruiting on behalf of an organization.',
    organizationInfoDescriptionSubtitle:
      'Provide your organization details so our team can review your OBNL eligibility.',
  },
  lastName: 'Last Name',
  lastNamePlaceholder: 'Enter your last name',
  city: 'City',
  cityPlaceholder: 'Enter your city',
  servicesOffered: 'Services offered',
  servicesHint: 'Add another service',
  languagesSpoken: 'Languages spoken',
  remoteWork: 'Do you work remotely',
  yes: 'Yes',
  professionalDescription: 'Describe your professional practice',
  professionalDescriptionPlaceholder:
    'Describe your professional experience, skills, and what makes you unique',
  professionalDescriptionNotice:
    "Personal contact details aren't allowed in profiles. Don't worry—they're shared automatically once you've connected on Pigeons!",
  charactersRemaining: 'characters remaining',
  businessIndustries: 'Business Industries',
  businessIndustriesHint: 'Add at least 1 business industry',
  companyName: 'Company name',
  companyNamePlaceholder: 'Enter your company name',
  jobTitle: 'Your title in the organization',
  jobTitlePlaceholder: 'Enter your title in the organization',
  organizationWebsite: 'Organization website',
  organizationWebsitePlaceholder: 'Enter your organization website',
  organizationNumber: 'Organization number',
  organizationNumberPlaceholder: 'Enter your organization number',
  organizationIdentityHint: 'Provide at least a website or an organization number.',
  organizationIdentityRequired:
    'Provide at least one organization identifier: website or organization number.',
  contactFirstName: 'Contact FirstName',
  contactLastName: 'Contact LastName',
  contactRoleInCompany: 'Contact Role in Company',
  back: 'Back',
  completeProfileCta: 'Complete profile',
  completeProfileCtaSubmitting: 'Completing profile...',
  fieldRequired: 'This field is required.',
  profileUpdateError: 'Error updating profile. Please try again.',
  profileUpdateSuccess: 'Profile updated successfully!',
  improveProfileStep: {
    welcome: 'Welcome to Pigeons',
    tabs: {
      settings: 'My settings',
      edit: 'Edit my profile',
      services: 'My services',
      achievements: 'My achievements',
      security: 'Authentication and security',
      publicProfile: 'My public profile',
    },
    step: 'Step 3 of 3',
    completeInfo: 'Enhance your profile and maximize your chances!',
    stepDesc:
      'A complete profile attracts more attention from recruiters, potential partners, and colleagues. It increases your chances of being noticed and contacted for interesting opportunities.',
    save: 'Save',
    services: {
      title: 'My Services',
      toImplement: 'My Services - to be implemented',
      label: 'Services offered',
      placeholder: 'Choice',
      hourlyRate: 'Hourly rate',
      add: 'Add a service',
      remove: 'Remove',
    },
    achievements: {
      title: 'My Achievements',
      toImplement: 'My Achievements - to be implemented',
      projectName: 'Project name',
      client: 'Client',
      description: 'Description',
      projectDetailsLabel: 'Project details',
      projectDetailsPlaceholder:
        'Describe the project you completed. Mention the context, your role, and the outcome.',
      serviceOffered: 'Service offered',
      uploadImage: 'Upload an image',
      add: 'Add achievement',
      close: 'Close',
      saving: 'Saving...',
      imageUploadHint: 'Add an image',
      modify: 'Modify an achievement',
      save: 'Save',
      delete: 'Delete achievement',
      imageSize: 'The maximum image size is 5 MB',
      deleteSuccess: 'Achievement deleted successfully.',
      deleteError: 'Failed to delete achievement.',
    },
    security: {
      title: 'Security and Password',
      toImplement: 'Security and Password - to be implemented',
      changePassword: 'Change my password',
      currentPassword: 'Your current password',
      newPassword: 'Your new password',
      twoFA: 'Two-factor authentication',
      activated: 'Activated',
      deactivated: 'Deactivated',
      phone: 'Your phone number',
      confirmPhone: 'Confirm your phone number',
      passwordResetLinkSent: 'We have just sent an email to your ',
      passwordResetHint:
        'You will receive an email with a confirmation link to change your password',
      passwordResetEffective: 'Your new password is now effective.',
      passwordResetConfirmed:
        'You have confirmed your new password. You can now use it to sign in.',
    },
  },
  postalCodePlaceholder: 'Enter your postal code',
  phonePlaceholder: 'Enter your phone number',
  postalCode: 'Postal Code',
  phone: 'Phone',
  saving: 'Saving...',
  submitting: 'Submitting...',
  resetPasswordCta: 'Reset Password',
  backToHome: 'Back to Home',
  resetPassword: {
    title: 'Reset Password',
    description: 'Please enter your new password below.',
    newPassword: 'New password',
    confirmPassword: 'Confirm new password',
    save: 'Save',
    resetLinkSent:
      "We've just sent a reset link to <bold>{{email}}</bold>. Click the link to continue resetting your password.",
    resend: 'Resend reset email',
    resetPasswordCta: 'Reset',
    passwordsDoNotMatch: 'Passwords do not match',
    updateError: 'Failed to update password. Please try again.',
    expiredTitle: 'This reset link has expired',
    invalidLink:
      'This password reset link is invalid or has expired. Please request a new reset email.',
    sessionError:
      'We could not verify your reset link. Please request a new reset email and try again.',
    requestNewLink: 'Request a new reset link',
  },
  common: {
    save: 'Save',
  },
  login: {
    error: 'We could not sign you in. Please check your email and password.',
    invalid_credentials: 'Invalid email or password.',
    email_not_confirmed: 'Please confirm your email address before signing in.',
  },
  accountCard: {
    title: 'My Account',
    settings: 'My Settings',
    wallet: 'My Wallet',
    payment: 'Payment',
    signOut: 'Sign Out',
  },
  demoWalkthroughStep: {
    welcome: "You're all set!",
    step: 'One last thing...',
    completeInfo: 'Discover your dashboard',
    stepDesc:
      'Before you dive in, take a quick guided tour to see how Pigeons works. It only takes a minute and will help you get the most out of the platform.',
    tryCta: 'Take the guided tour',
    skipCta: 'Skip to dashboard',
  },
  navBar: {
    prospects: 'Prospects',
    alliances: 'Alliances',
    jobs: 'Job Offers',
    bids: 'Submissions',
    projects: 'Project Manager',
    credits: 'My tokens',
    contacts: 'Contacts',
  },
} as const;
